class MoneyTool {
    format(amount, withDecimals) {
        amount = withDecimals ? parseFloat(amount).toFixed(2) : parseInt(amount, 10);
        return 'K'+ amount;
    }
}

export default new MoneyTool;
